<div
  id="component-ys-inner-{{ component.id }}"
  class="ql-editor"
  [innerHtml]="htmlString"
></div>
